"use client";

import React from "react";

const LogoAnimado = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 300 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>{`
        .outer {
          fill: none;
          stroke: #3754a1;
          stroke-width: 20;
          stroke-linecap: round;
          stroke-dasharray: 440 200;
          transform-origin: 50% 50%;
          animation: spin-cw 6s linear infinite;
        }

        .inner {
          fill: none;
          stroke: #4162ab;
          stroke-width: 14;
          stroke-linecap: round;
          stroke-dasharray: 300 150;
          transform-origin: 50% 50%;
          animation: spin-ccw 6s linear infinite;
        }

        @keyframes spin-cw {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes spin-ccw {
          from { transform: rotate(0deg); }
          to { transform: rotate(-360deg); }
        }
      `}</style>

      {/* Círculos animados */}
      <circle className="outer" cx="150" cy="150" r="120" />
      <circle className="inner" cx="150" cy="150" r="90" />

      {/* Imagem central */}
      <image
        href="/assets/logosvg3.png"    
        x="80"             
        y="1"             
        width="700"         
        height="300"         
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  );
};

export default LogoAnimado;
